import { Controller } from "@hotwired/stimulus"

// Stimulus controller for collapsible submenus in secondary navigation
// Handles expand/collapse of submenu groups
export default class extends Controller {
  static targets = ["toggle", "submenu"]

  connect() {
    // Initialize chevron rotation based on collapsed state
    this.toggleTargets.forEach(toggle => {
      const collapsed = toggle.dataset.collapsed === "true"
      const chevron = toggle.querySelector('.secondary-sidebar-nav-chevron')
      if (chevron) {
        if (collapsed) {
          chevron.style.transform = 'rotate(0deg)'
        } else {
          chevron.style.transform = 'rotate(90deg)'
        }
      }
    })
  }

  toggle(event) {
    const button = event.currentTarget
    const submenuId = button.getAttribute('aria-controls')
    const submenu = document.getElementById(submenuId)
    const chevron = button.querySelector('.secondary-sidebar-nav-chevron')
    const isExpanded = button.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      // Collapse
      submenu.style.display = 'none'
      button.setAttribute('aria-expanded', 'false')
      button.dataset.collapsed = 'true'
      if (chevron) {
        chevron.style.transform = 'rotate(0deg)'
      }
    } else {
      // Expand
      submenu.style.display = 'block'
      button.setAttribute('aria-expanded', 'true')
      button.dataset.collapsed = 'false'
      if (chevron) {
        chevron.style.transform = 'rotate(90deg)'
      }
    }
  }
}
